// Password gate wrapper for admin pages (analytics + affiliates).
// The password is verified SERVER-SIDE (POST /api/admin/verify) — no secret in the bundle.
import { useState } from "react";
import axios from "axios";
import { API } from "../../utils/apiUrl";

export const getAdminHeader = () => ({ "X-Admin-Password": sessionStorage.getItem("admin_pw") || "" });

const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(() => !!sessionStorage.getItem("admin_pw"));
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (unlocked) return children;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input || busy) return;
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/admin/verify`, { password: input });
      sessionStorage.setItem("admin_pw", input);
      localStorage.removeItem("admin_unlocked");
      setUnlocked(true);
    } catch (err) {
      setError(
        err?.response?.status === 429
          ? "Too many failed attempts — try again in 15 minutes"
          : "Incorrect password"
      );
      setInput("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pt-24 pb-16 px-4 min-h-screen flex items-center justify-center" data-testid="admin-password-gate">
      <div className="bg-slate-800/50 rounded-xl p-8 border border-slate-700/50 w-full max-w-sm">
        <h2 className="text-xl font-bold text-white mb-2 text-center" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          ADMIN ACCESS
        </h2>
        <p className="text-slate-400 text-sm text-center mb-6">Enter password to view analytics dashboard</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setError("");
            }}
            placeholder="Password"
            className="w-full px-4 py-3 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-green-500 mb-3"
            data-testid="admin-password-input"
            autoFocus
          />
          {error && (
            <p className="text-red-400 text-sm mb-3" data-testid="admin-password-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full px-4 py-3 bg-green-500 hover:bg-green-400 disabled:opacity-60 text-slate-950 font-bold rounded-lg transition-all"
            data-testid="admin-password-submit"
          >
            {busy ? "Checking…" : "Unlock"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordGate;
